import { uniqueId } from "lodash";
import { useEffect, useState } from "react";
import { LoadingStatus } from "../../enums/loadingStatus";
import Button, { ButtonTypes } from "../button/button";
import TextField from "../inputFields/textFields/textField";
import "./table.scss";

export default function Table(props: {
  columns: Array<{ key: string; value: string; width?: string }>;
  rows?: Array<Array<{ key: string; value: any }>>;
  loadingStatus?: LoadingStatus;
  noSpace?: boolean;
  emptySpace?: any;
}) {
  const [displayRows, setDisplayRows] = useState(props.rows);
  const [serachText, setSerachText] = useState("");

  useEffect(() => {
    setDisplayRows(props.rows);
  }, [props.rows]);

  return (
    <div>
      <div className={"table-container"}>
        <div className="search-container">
          <TextField
            isFullWidth={true}
            maxWidth={300}
            onChange={(e) => setSerachText(e)}
          />
          <Button
            type={ButtonTypes.OUTLINED}
            text={"search"}
            onClick={() => {
              setDisplayRows(
                [...(props.rows ?? [])].filter(
                  (row) =>
                    serachText.trim() == "" ||
                    row.some((data) =>
                      typeof data.value == "string"
                        ? data.value
                            .toLowerCase()
                            .includes(serachText.toLowerCase())
                        : false
                    )
                )
              );
            }}
          />
        </div>
        <table className={"table"}>
          <thead>
            <tr>
              {props.columns.map((e) => {
                return <th key={uniqueId()}>{e.value}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {/* real contents */}
            {props.loadingStatus == LoadingStatus.SUCCESS
              ? displayRows?.map((e, i) => (
                  <tr key={uniqueId()} className={i === 0 ? "first-row" : ""}>
                    {props.columns.map((column) => (
                      <td
                        key={uniqueId()}
                        style={{
                          width: column.width,
                        }}
                      >
                        {e.filter((e) => e.key == column.key)?.[0]?.value || ""}
                      </td>
                    ))}
                  </tr>
                ))
              : // loading skeleton
                Array(3)
                  .fill(null)
                  .map((e, i) => (
                    <tr key={uniqueId()} className={i === 0 ? "first-row" : ""}>
                      {props.columns.map((column) => (
                        <td
                          key={uniqueId()}
                          style={{
                            width: column.width,
                          }}
                        >
                          <div
                            className="table-skeleton"
                            style={{ width: "100px", height: "20px" }}
                          ></div>
                        </td>
                      ))}
                    </tr>
                  ))}
          </tbody>
        </table>
        {props.rows?.length == 0 && props.emptySpace}
      </div>
    </div>
  );
}
